// products modules
import axios from '@/api/http_client';
import {getToken} from '@/common'
import { CATEGORY_URL, CATEGORY_2_URL, PRODUCT_GREAT_DEALS_URL, PRODUCTS_URL, PRODUCTS_GROUP, BRAND_OPTIONS_URL, FAVORITES_URL, FAVORITES_UNFAVORITE_URL, GET_COMPANY_URL, GET_WAREHOUSE_BY_COMPANY_URL } from '../../api/url.js';

// initial state
const state = {
  activeCategory: '',
  activeCategory2: '',
  activeProduct: '',
  // allGroups: [],
  customCategories: [], // api categorie 2
  productDetails: '',
  activeQuantity: 0,

  selectedGroupGlobal: [],
  selectedCustomCategoryGlobal: [],
  selectedCategoryGlobal: [],
  selectedSearchGlobal: [],
  favoriteSuccess: false,
  favoriteLoading: false,
  favoriteError: false,
  companyId: 1,
  warehouseId: 1,
  showPrice: true
}

// actions
const actions = {
  // allGroupsCategories:
  fetchCategories: ({ commit }, {id,company_id,warehouse_id}) => axios({ url: `${CATEGORY_URL}${id}?warehouse_id=${warehouse_id}&company_id=${company_id}`, method: 'GET', headers: {Location: localStorage.getItem('warehouseLocationWeb')}}),
  fetchCustomCategories(context,{company_id,warehouse_id}) {
    const config = {
      method: 'get',
      url: CATEGORY_2_URL,
      params: {
        IsListView: true,
        nested: true,
        company_id,
        warehouse_id
      },
      headers: {Location: localStorage.getItem('warehouseLocationWeb')},
    };
    axios(config)
    .then((response) => {
      context.commit('fetchCustomCategories', response.data);
    }, (err) => {
      console.log("fetchCustomCategories error:", err);
    })
  },
  fetchProductDetails(context, productNum) {
    const config = {
      method: 'get',
      url: `${PRODUCTS_URL}${productNum}`,
      headers: {Location: localStorage.getItem('warehouseLocationWeb')},
    };
    axios(config)
    .then((response) => {
      context.commit('fetchProductDetails', response.data);
    }, (err) => {
      console.log("fetchProductDetails error:", err);
    })
  },
  addProductToFavorites(context, productId) {
    const token = getToken();
    const config = {
      method: 'POST',
      url: `${FAVORITES_URL}${productId}`,
      headers: {
        Location: localStorage.getItem('warehouseLocationWeb'),
        Authorization: `JWT ${token}`
      },
    };
    context.commit('favoritedLoading')
    axios(config)
    .then((res) => {
      context.commit("favoritedSuccessful")
    }, (err) => {
      context.commit("favoritedFailed")
    })
  },
  removeProductFromFavorites(context, productId) {
    const token = getToken();
    const config = {
      method: 'POST',
      url: `${FAVORITES_UNFAVORITE_URL}${productId}`,
      headers: {
        Location: localStorage.getItem('warehouseLocationWeb'),
        Authorization: `JWT ${token}`
      },
    };
    context.commit('favoritedLoading')
    axios(config)
    .then((res) => {
      context.commit("favoritedSuccessful")
    }, (err) => {
      context.commit("favoritedFailed")
    })
  },
  getFavorites(context) {
    const token = getToken();
    const config = {
      method: 'GET',
      url: `${FAVORITES_URL}`,
      headers: {
        Location: localStorage.getItem('warehouseLocationWeb'),
        Authorization: `JWT ${token}`
      },
    };
    return axios(config)
  },
  fetchProductsWithGroupId: ({ commit }, {id,company_id,warehouse_id}) => axios({ url: `${PRODUCTS_GROUP}/${id}?warehouse_id=${warehouse_id}&company_id=${company_id}`, method: 'GET', headers: {Location: localStorage.getItem('warehouseLocationWeb')}}),
  fetchProductsWithGroupAll: ({ commit }, data) => axios({ url: `${PRODUCTS_GROUP}/`, method: 'GET', headers: {Location: localStorage.getItem('warehouseLocationWeb')}}),
  fetchProductsWithCategory2Id: ({ commit }, data) => axios({ url: `${CATEGORY_2_URL}${data}`, method: 'GET', headers: {Location: localStorage.getItem('warehouseLocationWeb')}}),
  fetchProductsWithCustomCategoryId: ({ commit }, {id,company_id,warehouse_id}) => axios({ url: `${CATEGORY_2_URL}${id}?warehouse_id=${warehouse_id}&company_id=${company_id}`, method: 'GET', params: {IsListView: true, nested: false,}, headers: {Location: localStorage.getItem('warehouseLocationWeb')}}),
  fetchBrands: ({ commit }, {type, id}) => axios({ url: `${BRAND_OPTIONS_URL}?type=${type}&id=${id}`, method: 'GET', headers: {Location: localStorage.getItem('warehouseLocationWeb')}}),
  getCompany: ({ commit }) => axios({ url: `${GET_COMPANY_URL}`, method: 'GET', headers: {Location: localStorage.getItem('warehouseLocationWeb')}}),
  getWarehouseByCompany: ({ commit }, data) => axios({ url: `${GET_WAREHOUSE_BY_COMPANY_URL}/${data}`, method: 'GET', headers: {Location: localStorage.getItem('warehouseLocationWeb')}}),
  changeCompanyId(context, data){
    context.commit('changeCompanyId', data);
  },
  changeWarehouseId(context, data){
    context.commit('changeWarehouseId', data);
  },
  changeShowPrice(context, data){
    context.commit('changeShowPrice', data);
  },
};

// mutations
const mutations = {
  fetchCustomCategories(state, payload) {
    state.customCategories = payload;
  },
  updateActiveCategory(state, data) {
    state.activeCategory = data
  },
  fetchProductDetails(state, payload) {
    state.productDetails = payload
  },
  updateActiveProduct(state, number) {
    state.activeProduct = number
  },
  updateActiveQuantity(state, payload) {
    state.activeQuantity = payload;
  },
  updateSelectedGroupGlobal(state, payload) {
    state.selectedGroupGlobal = payload;
    state.selectedCustomCategoryGlobal = [];
    state.selectedCategoryGlobal = [];
    state.selectedSearchGlobal = [];
  },
  updateSelectedCustomCategoryGlobal(state, payload) {
    state.selectedGroupGlobal = [];
    state.selectedCustomCategoryGlobal = payload;
    state.selectedCategoryGlobal = [];
    state.selectedSearchGlobal = [];
  },
  updateSelectedCategoryGlobal(state, payload) {
    state.selectedGroupGlobal = [];
    state.selectedCustomCategoryGlobal = [];
    state.selectedCategoryGlobal = payload;
    state.selectedSearchGlobal = [];
  },
  updateSelectedSearchGlobal(state, payload) {
    state.selectedGroupGlobal = [];
    state.selectedCustomCategoryGlobal = [];
    state.selectedCategoryGlobal = [];
    state.selectedSearchGlobal = payload;
  },
  favoritedSuccessful(state, payload) {
    state.favoriteSuccess = true;
    state.favoriteLoading = false;
    state.favoriteError = false;
  },
  favoritedFailed(state, payload) {
    state.favoriteSuccess = false;
    state.favoriteLoading = false;
    state.favoriteError = true;
  },
  favoritedLoading(state, payload) {
    state.favoriteSuccess = false;
    state.favoriteLoading = true;
    state.favoriteError = false;
  },
  changeCompanyId(state, payload){
    state.companyId = payload;
  },
  changeWarehouseId(state, payload){
    state.warehouseId = payload;
  },
  changeShowPrice(state, payload){
    state.showPrice = payload;
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/products.js